// extracted by mini-css-extract-plugin
export var completionBody = "_mf-2";
export var completionCard = "_mf-0";
export var completionFooter = "_mf-3";
export var completionTitle = "_mf-1";